(() => {
  const bh = document.getElementById('bh');
  /* header: solid after scrolling, hide on the way down, return on the way up */
  if (bh) {
    let last = scrollY, ticking = false;
    const busy = () => document.querySelector('.drawer.on,.search.on');
    const upd = () => {
      const y = scrollY;
      bh.classList.toggle('solid', y > 40);
      if (!busy()) {
        if (y > last + 4 && y > 160) bh.classList.add('hide');
        else if (y < last - 4 || y < 160) bh.classList.remove('hide');
      }
      last = y; ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* menu: sliding panels + hover image */
  const menu = document.getElementById('menu');
  if (menu) {
    const panels = [...menu.querySelectorAll('.bm-panel')];
    const feat = menu.querySelector('.bm-feature img');
    const show = name => {
      panels.forEach(p => {
        const on = p.dataset.panel === name;
        p.classList.toggle('on', on);
        p.classList.toggle('out', !on && name !== 'root' && p.dataset.panel === 'root');
        p.setAttribute('aria-hidden', String(!on));
      });
      const first = menu.querySelector(`.bm-panel[data-panel="${name}"] a, .bm-panel[data-panel="${name}"] button`);
      setTimeout(() => first && first.focus({ preventScroll: true }), 120);
    };
    menu.addEventListener('click', e => {
      const go = e.target.closest('[data-go]');
      if (go) { show(go.dataset.go); return; }
      if (e.target.closest('[data-back]')) show('root');
    });
    let cur = feat && feat.src, t;
    menu.addEventListener('mouseover', e => {
      const el = e.target.closest('[data-img]'); if (!el || !feat) return;
      const src = el.dataset.img; if (!src || src === cur) return;
      cur = src; clearTimeout(t); feat.classList.add('fade');
      t = setTimeout(() => { feat.src = src; feat.onload = () => feat.classList.remove('fade'); }, 180);
    });
    const opener = document.getElementById('open-menu');
    if (opener) opener.addEventListener('click', () => show('root'));
  }

  /* reveal sections as they scroll in */
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const els = document.querySelectorAll('main .sh, main .cats, main .grid, main .split, main .tile.wide, main .skins, main .size-tool, main .mto .in, main .svc, main .intro, main .c-foot, main .related');
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach(el => { if (el.getBoundingClientRect().top > innerHeight * 0.9) { el.classList.add('rv'); io.observe(el); } });
  }
})();

/* ---- finishing fixes ---- */
(() => {
  /* prices in the bag and search use the shop's own money format (Rs.239,800.00), not the browser's */
  const CW = window.CW || {}, f = CW.moneyFormat, Base = Intl.NumberFormat;
  if (f && /\{\{\s*\w+\s*\}\}/.test(f)) {
    const fmt = v => {
      const n = (d, ts = ',', ds = '.') => { const [i, dd] = Math.abs(v).toFixed(d).split('.'); return (v < 0 ? '-' : '') + i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (dd ? ds + dd : ''); };
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => k === 'amount_no_decimals' ? n(0) : k === 'amount_with_comma_separator' ? n(2, '.', ',') : k === 'amount_no_decimals_with_comma_separator' ? n(0, '.') : k === 'amount_with_apostrophe_separator' ? n(2, "'") : n(2));
    };
    const Patched = function (loc, o) {
      const real = new Base(loc, o);
      if (o && o.style === 'currency' && o.currency === CW.currency) return { format: v => fmt(+v || 0), formatToParts: v => [{ type: 'literal', value: fmt(+v || 0) }], resolvedOptions: () => real.resolvedOptions() };
      return real;
    };
    Patched.supportedLocalesOf = Base.supportedLocalesOf;
    Intl.NumberFormat = Patched;
  }

  /* size converter: switching US / UK / EU keeps the size you picked */
  document.querySelectorAll('[data-size-tool]').forEach(tool => {
    const seg = tool.querySelector('[data-sys]'), sel = tool.querySelector('[data-sz-in]'), us = tool.querySelector('[data-r="us"]');
    if (!seg || !sel || !us) return;
    seg.addEventListener('click', e => {
      const b = e.target.closest('[data-v]'); if (!b) return;
      const cur = parseFloat(us.textContent); if (!(cur > 0)) return;
      setTimeout(() => {
        const v = b.dataset.v === 'uk' ? cur - 1 : b.dataset.v === 'eu' ? Math.round(cur + 33) : cur;
        if ([...sel.options].some(o => +o.value === v)) { sel.value = String([...sel.options].find(o => +o.value === v).value); sel.dispatchEvent(new Event('change', { bubbles: true })); }
      }, 0);
    }, true);
  });
})();
